/*
 * @params {string} param
 * @return string | undefined
 * */
export function getParamFromSearch(param) {
  const search = window.location.search;

  if (!search.includes(param)) return undefined;

  const params = search
    .slice(1)
    .split("&")
    .map((item) => item.split("="));

  for (const item of params) {
    if (item[0] === param) return decodeURI(item[1]);
  }

  return undefined;
}
